export default "__VITE_ASSET__DWFeHKz0__"